import {
  uploadResumePending,
  uploadResumeSuccess,
  uploadResumeError,
  getResumePending,
  getResumeSuccess,
  getResumeError,
  deleteResumePending,
  deleteResumeSuccess,
  deleteResumeError,
} from "../actions/resume";
import { UserService, ApplicantDashboard } from "../../lib/qc-api-client";

export function uploadResume(userId, profileId, data, name) {
  return (dispatch) => {
    dispatch(() => dispatch(uploadResumePending()));
    UserService.uploadResume(userId, profileId, data)
      .then((response) => {
        return dispatch(
          uploadResumeSuccess({
            ...response.data.resume,
            name: `${+new Date()}-${name}`,
          })
        );
      })
      .catch((error) => dispatch(uploadResumeError(error.message)));
  };
}

export function getResumes(user) {
  return (dispatch) => {
    dispatch(getResumePending());
    ApplicantDashboard.getData(user)
      .then((response) => dispatch(getResumeSuccess(response.data.resumes)))
      .catch((error) => dispatch(getResumeError(error)));
  };
}

export function deleteResume(user, resume) {
  return (dispatch) => {
    dispatch(deleteResumePending());
    UserService.removeResume(user, resume)
      .then((response) => dispatch(deleteResumeSuccess(response.data.resume)))
      .catch((error) => dispatch(deleteResumeError(error)));
  };
}
